<template>
  <div>
    <b-row>
      <!-- Company Name -->
      <b-col
        md="6"
        sm="12"
      >
        <b-form-group
          label="Company Name"
          label-for="v-company-name"
        >
          <b-form-input
            id="v-company-name"
            v-model="dataForm.company_name"
            placeholder="Company Name"
          />
        </b-form-group>
      </b-col>
      <!-- End Company Name -->
      
      <!-- NPWP -->
      <b-col
        md="6"
        sm="12"
      >
        <b-form-group
          label="NPWP"
          label-for="v-npwp_number"
        >
          <b-form-input
            id="v-npwp_number"
            v-model="dataForm.npwp_number"
            placeholder="NPWP Number"
          />
        </b-form-group>
      </b-col>
      <!-- End NPWP -->

      <!-- Business Field -->
      <b-col
        md="6"
        sm="12"
      >
        <b-form-group
          label="Business Field"
          label-for="v-business-field"
        >
          <b-form-input
            v-if="!edit"
            id="v-business-field"
            v-model="dataForm.business_field_name"
            placeholder="Business Field"
          />
          <v-select
            v-if="edit"
            v-model="dataForm.business_field_id"
            input-id="v-business-field"
            placeholder="Please select"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            label="title"
            :options="option"
          />
        </b-form-group>
      </b-col>
      <!-- End Business Field -->

      <!-- Company Type -->
      <b-col
        md="6"
        sm="12"
      >
        <b-form-group
          label="Company Type"
          label-for="v-company-type"
        >
          <b-form-input
            v-if="!edit"
            id="v-company-type"
            v-model="dataForm.company_type_name"
            placeholder="Company Type"
          />
          <v-select
            v-if="edit"
            v-model="dataForm.company_type_id"
            input-id="v-company-type"
            placeholder="Please select"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            label="title"
            :options="option"
            class="select-size-md"
          />
        </b-form-group>
      </b-col>
      <!-- Company Type -->

      <!-- Company Address -->
      <b-col cols="12">
        <b-form-group
          label="Company Address"
          label-for="v-company-address"
        >
          <b-form-textarea
            id="v-company-address"
            v-model="dataForm.company_address"
            placeholder="Company Address"
            rows="4"
          />
        </b-form-group>
      </b-col>
      <!-- End Company Address -->

      <!-- Country -->
      <b-col
        md="6"
        sm="12"
      >
        <b-form-group
          label="Country"
          label-for="v-country"
        >
          <b-form-input
            v-if="!edit"
            id="v-country "
            v-model="dataForm.country_name"
            placeholder="Country"
          />
          <v-select
            v-if="edit"
            v-model="dataForm.country_id"
            input-id="v-country"
            placeholder="Please select"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :reduce="name => name.id"
            label="name"
            :options="optionCountry"
            class="select-size-md"
          />
        </b-form-group>
      </b-col>
      <!-- End Country -->

      <!-- Province -->
      <b-col
        md="6"
        sm="12"
      >
        <b-form-group
          label="Province"
          label-for="v-province"
        >
          <b-form-input
            v-if="!edit"
            id="v-province"
            v-model="dataForm.province_name"
            placeholder="Province"
          />
          <v-select
            v-if="edit"
            v-model="dataForm.province_name"
            input-id="v-province"
            placeholder="Please select"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            label="title"
            :options="option"
            class="select-size-md"
          />
        </b-form-group>
      </b-col>
      <!-- End Province -->

      <!-- City -->
      <b-col
        md="6"
        sm="12"
      >
        <b-form-group
          label="City"
          label-for="v-city"
        >
          <b-form-input
            v-if="!edit"
            id="v-city"
            v-model="dataForm.city_name"
            placeholder="City"
          />
          <v-select
            v-if="edit"
            v-model="dataForm.city_name"
            input-id="v-city"
            placeholder="Please select"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            label="title"
            :options="option"
            class="select-size-md"
          />
        </b-form-group>
      </b-col>
      <!-- End City -->

      <!-- Zip Code -->
      <b-col
        md="6"
        sm="12"
      >
        <b-form-group
          label="Zip Code"
          label-for="v-zip-code"
        >
          <b-form-input
            id="v-zip-code"
            v-model="dataForm.zip_code"
            placeholder="Zip Code"
          />
        </b-form-group>
      </b-col>
      <!-- End Zip Code -->

      <!-- Bank Name -->
      <b-col
        md="6"
        sm="12"
      >
        <b-form-group
          label="Bank Name"
          label-for="v-bank_name"
        >
          <b-form-input
            v-if="!edit"
            id="v-bank_name"
            v-model="dataForm.bank.bank_name"
            placeholder="Bank Name"
          />
          <v-select
            v-if="edit"
            v-model="dataForm.bank.bank_name"
            input-id="v-bank_name"
            placeholder="Please select"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            label="title"
            :options="option"
            class="select-size-md"
          />
        </b-form-group>
      </b-col>
      <!-- End Bank Name -->

      <!-- Bank Branch -->
      <b-col
        md="6"
        sm="12"
      >
        <b-form-group
          label="Bank Branch"
          label-for="v-bank-branch"
        >
          <b-form-input
            id="v-bank-branch"
            v-model="dataForm.bank.bank_branch"
            placeholder="Bank Branch"
          />
        </b-form-group>
      </b-col>
      <!-- End Bank Branch -->

      <!-- Bank Account Number -->
      <b-col
        md="6"
        sm="12"
      >
        <b-form-group
          label="Bank Account Number"
          label-for="v-bank-number"
        >
          <b-form-input
            id="v-bank-number"
            v-model="dataForm.bank.bank_account"
            placeholder="Bank Account Number"
          />
        </b-form-group>
      </b-col>
      <!-- Bank Account Number -->

      <!-- Bank Account Holder -->
      <b-col
        md="6"
        sm="12"
      >
        <b-form-group
          label="Bank Account Holder"
          label-for="v-bank-holder"
        >
          <b-form-input
            id="v-bank-holder"
            v-model="dataForm.bank.bank_holder"
            placeholder="Bank Account Holder"
          />
        </b-form-group>
      </b-col>
      <!-- Bank Account Holder -->
    </b-row>
    
    <b-row class="mb-2">
      <b-col cols="12">
        <h5 class="mt-1">
          Company Documents
        </h5>
        <b-button
          v-for="(value, name, index) in dataForm.document"
          :key="`doc-${index}`"
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="flat-secondary"
          :href="`${value}`"
          target="_blank"
          class="float-left width-1 px-0"
        >
          <b-img
            center
            class="mb-1 mb-sm-0 d-block"
            :src="imgPdf"
          />
          <span class="d-block mt-1">{{ name }}</span>
        </b-button>
      </b-col>
    </b-row>

    <validation-observer ref="credential" tag="form">
      <b-row v-if="role === 1 && dataForm.status === 2 && path === 'view'">
        <b-col md="7">
          <b-card style="background: #f0f0f0">
            <b-row class="align-items-end">
              <!-- client id -->
              <b-col
                md="5"
                sm="12"
              >
                <b-form-group
                  class="mb-0"
                  label="Client ID"
                  label-for="v-clientid-cred"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="client id"
                    rules="required"
                  >
                    <b-form-input
                      id="v-clientid-cred"
                      v-model="inputTelcoClientId"
                      :state="errors.length > 0 ? false : null"
                      placeholder="Client ID"
                      autocomplete="off"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <!-- last name -->
              <b-col
                md="4"
                sm="12"
              >
                <b-form-group
                  class="mb-0"
                  label="Password"
                  label-for="v-password-cred"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="campaign name"
                    rules="required"
                  >
                    <b-form-input
                      id="v-password-cred"
                      type="password"
                      v-model="inputTelcoClientSecret"
                      :state="errors.length > 0 ? false : null"
                      placeholder="Password"
                      autocomplete="new-password"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <b-col
                md="3"
                sm="12"
              >
                <b-button
                  variant="success"
                  class="mt-1 w-100"
                  @click="handleSetCredential"
                  v-if="(dataForm.telco_client_id === 'NOTSET' && dataForm.telco_client_secret === 'NOTSET') ||
                  (dataForm.telco_client_id === 'SET' && dataForm.telco_client_secret === 'NOTSET') ||
                  (dataForm.telco_client_id === 'NOTSET' && dataForm.telco_client_secret === 'SET')
                  "
                >
                  <span class="align-middle">Set</span>
                </b-button>
                <b-button
                  variant="warning"
                  class="mt-1 w-100"
                  @click="setCredentialUpdate"
                  v-if="dataForm.telco_client_id === 'SET' && dataForm.telco_client_secret === 'SET'"
                >
                  <span class="align-middle">Update</span>
                </b-button>
                <popup-credential ref="PopupCredentialStatus" />
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
    </validation-observer>
  </div>
</template>

<script>
import {
  BRow, BCol, BFormGroup, BFormInput, BFormTextarea, BCard, BImg, BButton,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import { mapActions, mapGetters, mapMutations } from 'vuex'

import { ValidationProvider, ValidationObserver, extend } from 'vee-validate'
import { required } from 'vee-validate/dist/rules'

import PopupCredential from '@/views/component/PopupCredential.vue'

extend('required', {
  ...required,
  message: 'This is required!',
})

export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormTextarea,
    vSelect,
    BImg,
    BButton,
    BCard,
    ValidationProvider,
    ValidationObserver,
    PopupCredential,
  },
  directives: {
    Ripple,
  },
  props: {
    // eslint-disable-next-line vue/require-default-prop
    dataForm: Object,
    edit: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      // eslint-disable-next-line global-require
      imgPdf: require('@/assets/images/pdf.png'),
      selected: { title: 'Square' },
      option: [{ title: 'Square' }, { title: 'Rectangle' }, { title: 'Rombo' }, { title: 'Romboid' }],
      optionCountry: [
        {
          id: null,
          name: 'select Country',
        },
      ],
      role: this.$store.state.auth.userData.data.Account.role_id,
      statusApprove: this.$store.state.account.statusApprove,
      path: window.location.pathname.split('/')[3],
    }
  },
  beforeMount() {
    this.resetCredential()
  },
  computed: {
    ...mapGetters('account', {
      clientId: 'getClientId',
      telcoClientId: 'getTelcoClientId',
      telcoClientSecret: 'getTelcoClientSecret',
    }),
    inputTelcoClientId: {
      get() {
        return this.telcoClientId
      },
      set(val) {
        this.setTelcoClientId(val)
      },
    },
    inputTelcoClientSecret: {
      get() {
        return this.telcoClientSecret
      },
      set(val) {
        this.setTelcoClientSecret(val)
      },
    },
  },
  mounted() {
    // console.log(this.dataForm);
  },
  methods: {
    ...mapActions('datas', [
      'dataCountry',
      'dataProvince',
      'dataCity',
    ]),
    setCountry() {
      this.dataCountry().then(() => {
        this.optionCountry = this.dataCountry
      })
    },
    setProvince(e) {
      const sendData = {
        id: e,
      }
      this.dataProvince(sendData).then(() => {
        this.optionProvince = this.dataProvince
      })
    },
    setCity(e) {
      const sendData = {
        id: e,
      }
      this.dataCity(sendData).then(() => {
        this.optionCity = this.dataCity
      })
    },

    ...mapActions('account', ['setTelcoCredential', 'resetCredential']),
    ...mapMutations('account', {
      setTelcoClientId: 'SET_TELCO_CLIENT_ID',
      setTelcoClientSecret: 'SET_TELCO_CLIENT_SECRET',
    }),
    handleSetCredential() {
      this.$refs.credential.validate().then((res) => {
        if(res === true) {
          this.setTelcoCredential().then((response) => {
            if (response.data.status) {
              this.success()
            } else {
              // const type = (response.data.status === 1) ? 1 : 2
              this.failed(response.data)
            }
          })
        }
      })
    },
    success() {
      this.$swal({
        title: 'Success!',
        text:
          'Set credential success',
        icon: 'success',
        customClass: {
          confirmButton: 'btn btn-primary',
        },
        buttonsStyling: false,
        allowOutsideClick: false,
      }).then((result) => {
        if (result.value) {
          this.$router.push({ name: 'account-partner' })
        }
      })
    },
    failed() {
      this.$swal({
        title: 'Failed!',
        text: '',
        icon: 'error',
        customClass: {
          confirmButton: 'btn btn-primary',
        },
        buttonsStyling: false,
        allowOutsideClick: false,
      })
    },
    setCredentialUpdate() {
      this.$refs.credential.validate().then((res) => {
        if(res === true) {
          this.$refs.PopupCredentialStatus.showModal()
        }
      })
    }
  },
}
</script>

<style scope>
/* .vs__search::placeholder,
.vs__dropdown-toggle,
.vs__dropdown-menu {
  background: #dfe5fb;
  border: none;
  color: #394066;
  text-transform: lowercase;
  font-variant: small-caps;
} */
.width-1 {
  width: 110px;
}
.vs__clear,
.vs__open-indicator {
  fill: #c3bfbf !important;
}
</style>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
